export const photoFrameModels = [
  {
    id: 'pf1',
    size: '12 x 18 in',
    image:
      'https://readdy.ai/api/search-image?query=classic%20solid%20teak%20wood%20photo%20frame%20hanging%20on%20a%20warm%20cream%20wall%20with%20a%20family%20portrait%20inside%2C%20soft%20natural%20window%20light%2C%20minimal%20elegant%20interior%2C%20warm%20amber%20tones%2C%20premium%20product%20photography&width=800&height=1000&seq=shabi-frame-01&orientation=portrait&nocache=true',
  },
  {
    id: 'pf2',
    size: '16 x 24 in',
    image:
      'https://readdy.ai/api/search-image?query=antique%20gold%20ornate%20baroque%20photo%20frame%20with%20an%20elegant%20portrait%20inside%2C%20luxury%20interior%20wall%2C%20warm%20golden%20ambient%20lighting%2C%20rich%20brown%20and%20gold%20tones%2C%20premium%20editorial%20product%20shot&width=800&height=1000&seq=shabi-frame-02&orientation=portrait&nocache=true',
  },
  {
    id: 'pf3',
    size: 'Set of 7',
    image:
      'https://readdy.ai/api/search-image?query=elegant%20gallery%20wall%20with%20a%20set%20of%20seven%20matching%20wooden%20photo%20frames%20showing%20family%20memories%2C%20warm%20ivory%20wall%2C%20soft%20natural%20lighting%2C%20minimal%20interior%20decor%2C%20warm%20neutral%20tones&width=800&height=1000&seq=shabi-frame-03&orientation=portrait&nocache=true',
  },
  {
    id: 'pf4',
    size: '10 x 14 in',
    image:
      'https://readdy.ai/api/search-image?query=modern%20frameless%20acrylic%20crystal%20photo%20block%20with%20a%20floating%20portrait%20print%2C%20clean%20minimal%20light%20interior%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20premium%20product%20photography&width=800&height=1000&seq=shabi-frame-04&orientation=portrait&nocache=true',
  },
  {
    id: 'pf5',
    size: '6 x 8 in',
    image:
      'https://readdy.ai/api/search-image?query=small%20table-top%20wooden%20photo%20frame%20on%20a%20brass%20easel%20stand%20beside%20a%20desk%20lamp%2C%20warm%20cosy%20interior%2C%20soft%20golden%20lighting%2C%20warm%20amber%20tones%2C%20lifestyle%20product%20photography&width=800&height=1000&seq=shabi-frame-05&orientation=portrait&nocache=true',
  },
  {
    id: 'pf6',
    size: '24 x 36 in',
    image:
      'https://readdy.ai/api/search-image?query=oversized%20large%20framed%20family%20portrait%20in%20an%20elegant%20warm%20living%20room%20above%20a%20sofa%2C%20soft%20natural%20light%2C%20rich%20brown%20and%20cream%20interior%2C%20interior%20design%20photography%2C%20warm%20tones&width=800&height=1000&seq=shabi-frame-06&orientation=portrait&nocache=true',
  },
]

export const printSamples = [
  {
    id: 'ps1',
    image:
      'https://readdy.ai/api/search-image?query=elegant%20stack%20of%20premium%20gold%20foil%20visiting%20cards%20on%20a%20warm%20wooden%20desk%2C%20soft%20studio%20lighting%2C%20luxury%20branding%20mockup%2C%20warm%20amber%20and%20cream%20tones%2C%20sharp%20detail&width=800&height=600&seq=shabi-print-01&orientation=landscape&nocache=true',
  },
  {
    id: 'ps2',
    image:
      'https://readdy.ai/api/search-image?query=clean%20set%20of%20printed%20staff%20identity%20cards%20with%20lanyards%20on%20a%20light%20desk%2C%20professional%20corporate%20print%20mockup%2C%20soft%20neutral%20lighting%2C%20warm%20tones%2C%20crisp%20detail&width=800&height=600&seq=shabi-print-02&orientation=landscape&nocache=true',
  },
  {
    id: 'ps3',
    image:
      'https://readdy.ai/api/search-image?query=open%20tri-fold%20brochure%20mockup%20on%20a%20warm%20marble%20surface%2C%20clean%20editorial%20layout%2C%20soft%20natural%20lighting%2C%20elegant%20print%20design%20presentation%2C%20warm%20neutral%20tones&width=800&height=600&seq=shabi-print-03&orientation=landscape&nocache=true',
  },
  {
    id: 'ps4',
    image:
      'https://readdy.ai/api/search-image?query=large%20format%20flex%20banner%20standee%20mockup%20in%20a%20bright%20shop%20entrance%2C%20vivid%20printed%20graphics%2C%20professional%20outdoor%20promotional%20print%2C%20warm%20tones%2C%20sharp%20detail&width=800&height=600&seq=shabi-print-04&orientation=landscape&nocache=true',
  },
]